import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Button from '../Parts/Button';
import ArrowToolTip from "../common/ArrowToolTip";

const styles = () => ({
  root: {
    width: "100%",
    height: "65px",
    transition: 'transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  menuItem: {
    display: 'inline-flex',
    marginRight: 25,
  },

  deselect: {
    textDecoration: 'underline',
  },

  flex: {
    flex: 1,
  },

  appBar: {
    color: "#181819",
    background: "#FFFFFF",
    padding: '0px 20px',
    boxShadow: '11px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    margin: 'auto 0'
  },

  btn: {
    borderRadius: '2px',
    fontSize: 15,
    color: '#1A65FF',
    height: '40px',
    backgroundColor: '#F2F6FF',
    border: 'none',
    width: '200px',
    '&:hover': {
      backgroundColor: '#F2F6FF',
      opacity: .6,
    }
  },

  disabledBtn: {
    borderRadius: '2px',
    fontSize: 15,
    color: "#181819",
    height: '40px',
    backgroundColor: '#D8DBDF',
    border: 'none',
    width: '200px',
    '&:hover': {
      backgroundColor: '#D8DBDF',
      opacity: .6,
    }
  },

  letterSendBtn: {
    borderRadius: '2px',
    fontSize: 15,
    color: '#FFFFFF',
    height: '40px',
    width: '200px',
    backgroundColor: '#1A65FF',
    border: 'none',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },
});

class BottomButtonMenu extends React.Component {
  handleClick = (item) => {
    if (this.props.isDemo) {
      this.props.togglePlanDialog();
    } else {
      item.action();
    }
  };

  handleDeselect = () => {
    this.props.deselectAll(false);
  };

  render() {
    const { classes, menuItems, open } = this.props;
    return (
      <div className={classes.root} style={{ transform: open ? 'translateY(0%)' : 'translateY(100%)', visibility: open ? 'visible' : 'hidden' }}>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Toolbar style={{ padding: 0 }}>
            <Typography
              variant="subheading"
              style={{ fontWeight: 'bold' }}
              className={classNames(classes.menuItem)}
            >
              {this.props.numSelected} 項目選択中
            </Typography>

            {!this.props.isMinLetterOrderCount && (
              <Typography
                variant="body1"
                style={{ marginRight: 15 }}
              >
                {this.props.minLetterOrderCount}件以上から注文可能
              </Typography>
            )}

            <Typography
              onClick={this.handleDeselect}
              variant="body1"
              className={classNames('clickable', classes.deselect)}>
              選択を解除
            </Typography>

            <div className={classes.flex}></div>
            {menuItems.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  {(item.disableMessage) ? (
                    <div>
                      <ArrowToolTip
                        text={item.disableMessage}
                        placement="top"
                      >
                        <div>
                          <Button
                            className={item.disabled === true ? classes.disabledBtn : (item.text === 'レター送付' ? classes.letterSendBtn : classes.btn)}
                            text={item.text}
                            style={{ marginRight: (index === menuItems.length - 1) ? "0px" : "10px", pointerEvents: (item.disabled === true) ? 'none' : '' }} // disabled属性だとホバーアウトした場合、ツールチップが消えないので、pointerEventsで代用
                            handleClickButton={() => alert('ご利用いただけません。')}
                            key={index}
                          />
                        </div>
                      </ArrowToolTip>
                    </div>
                  ) : (
                    <Button
                      className={item.disabled === true ? classes.disabledBtn : (item.text === 'レター送付' ? classes.letterSendBtn : classes.btn)}
                      text={item.text}
                      style={{ marginRight: (index === menuItems.length - 1) ? "0px" : "10px" }}
                      handleClickButton={() => this.handleClick(item)}
                      disabled={item.disabled === true}
                      key={index}
                    />
                  )}
                </React.Fragment>
              )
            })}
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

BottomButtonMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number,
  deselectAll: PropTypes.func.isRequired,
  menuItems: PropTypes.array.isRequired, // array of { text, action}
  open: PropTypes.bool,
  isMinLetterOrderCount: PropTypes.bool,
  minLetterOrderCount: PropTypes.number,
  isDemo: PropTypes.bool,
  togglePlanDialog: PropTypes.func,
};

BottomButtonMenu.defaultProps = {
  isMinLetterOrderCount: true,
};

export default withStyles(styles)(BottomButtonMenu);



// WEBPACK FOOTER //
// ./src/components/common/BottomButtonMenu.jsx